import request from "@/utils/request";
export const getAboutInfo = () => {
    return request.get("/about/info");
};
export const updateAboutInfo = (data) => {
    return request.put("/about/info", data);
};
